/* eslint-disable */
export default {
  lang: {
    zh: '中文',
    en: 'English',
    sp: 'Español'
  },
  nav: {
    home: 'HOME',
    product: 'PRODUCT',
    news: 'NEWS',
    aboutUs: 'ABOUT US',
    contactUs: 'CONTACT US',
    tips: 'support searching by car model or car parts'
  },
  title: {
    oneDream: 'One Dream',
    guestDepartment: 'Sales Market',
    contact: 'Contact',
    contactUs: 'Contact us',
    QRCode: 'QR Code',
    product: 'Product',
    pressCenter:'New Center',
    companyProfile: 'About Us',
    developmentPath: 'Development Path',
    honor: 'Honor',
    aboutUs: 'About Us'
  },
  other: {
    keyWords: 'keyWords',
    search: 'Search',
    readMore: 'Read More',
    noMore: 'No more',
    selectProduct: 'Select product category',
    choose: 'Choose category',
    prompt: 'prompt',
    contactService: 'contact us by mail sales@dertparts.com for getting the E-Catalogues. '
  },
  product: {
    classify: 'search',
    noDataText: 'no data'
  }
}